import Input from '../Fields/Input';
import RadioCards from '../Fields/RadioCards';
import Select from '../Fields/Select';
import SelectSearch from '../Fields/SelectSearch';
import Checkbox from '../Fields/Checkbox';
import NullCheckbox from '../Fields/NullCheckbox';
import Textarea from '../Fields/Textarea';
import CkEditor from '../Fields/CkEditor';
import FieldWrapper from '../FormHandler/FieldWrapper';
import { CustomField } from '../Fields/CustomField';
import CheckboxCards from '../Fields/CheckboxCards';
import { forwardRef, useState } from "react";
import DatetimeField from './Datetime';
import FieldPopover from './FieldPopover';
import FileInput from './FileInput';
import ImageInput from './ImageInput';
import DateField from './Date';
import Color from './Color';
import Duration from './Duration';
import PercentageField from './PercentageInput';
import InputRange from './InputRange';
import NestedForm from './NestedForm';
import ManyNestedForm from './ManyNestedForm';
import JSONField from './JSONField';
import Period from './Period';
import Radio from './Radio';
import Rating from './Rating';
import { getValueByFieldName } from '../functions/getValueByFieldName';
import FloatingInput from './FloatingInput';

const FieldRenderer = forwardRef(({id, pk, index, formIndex, inline, template, field, values, onChange, classCallback, loading, error, popover, popoverTarget, excludeWrapper = false, excludeLabel=false, focus=false}, ref) => {
    const key = id + '_' + index
    const safeField = field
    let tmpl = template
    if (!tmpl && safeField?.template) tmpl = safeField.template
    tmpl = (tmpl || '').replace('.html', '')

    const resolvedFromValues =
      values != null && safeField?.fieldName != null
        ? getValueByFieldName(values, safeField.fieldName)
        : undefined
    const mergedField =
      safeField && resolvedFromValues !== undefined
        ? { ...safeField, value: resolvedFromValues }
        : safeField || {}

    const [selectedValue, setSelectedValue] = useState(
        tmpl === 'select_search' && mergedField.options ? mergedField.options.find(e => e.id == mergedField.value)?.label : null
    )
    const localOnChange = (e) => {
        setSelectedValue(e.label || e.value)
        onChange(e, mergedField.autoSave,  mergedField.reload, formIndex, mergedField.fieldName)
    }
    var element;
    var fieldClass = 'form-group';

    if (!field) {
        return null
    }
    if(mergedField.readOnly){
        return null
    }
    if( tmpl == 'image'){
        element = <ImageInput key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl == 'file' || (tmpl == 'input' && mergedField.inputType == 'file')){
        element = <FileInput key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl == 'percentage'){
        element = <PercentageField key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'input_range'){
        element = <InputRange key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'input_floating'){
        element = <FloatingInput key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'input'){
        element = <Input key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'color'){
        element = <Color key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'duration'){
        element = <Duration key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'period'){
        element = <Period key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'rating'){
        element = <Rating key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'datetime'){
        element = <DatetimeField key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'date'){
        element = <DateField key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk}/>
    }
    else if(tmpl === 'textarea'){
        element = <Textarea key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
    }
    else if(tmpl === 'json'){
        element = <JSONField key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
    }
    else if(tmpl === 'radio_cards'){
        element = <RadioCards key={key} {...mergedField} ref={ref} onChange={localOnChange}  pk={pk}/>
        fieldClass += ' radio-wrapper'
    }
    else if(tmpl === 'checkbox_cards'){
        element = <CheckboxCards key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
        fieldClass += ' radio-wrapper'
    }
    else if(tmpl === 'select'){
        element = <Select key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
    }
    else if(tmpl === 'select_search'){
        element = <SelectSearch popoverTarget={popoverTarget} key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
    }
    else if(tmpl === 'radio'){
        element = <Radio key={key} {...mergedField} ref={ref} onChange={localOnChange}  pk={pk}/>
    }
    else if(tmpl === 'checkbox'){
        element = <Checkbox additionalClass='ms-0' key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
        fieldClass += ' form-switch'
    }
    else if(tmpl === 'null_checkbox'){
        element = <NullCheckbox key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
    }
    else if(tmpl === 'ckeditor'){
        element = <CkEditor key={key} {...mergedField} ref={ref} onChange={localOnChange}  pk={pk}/>
        excludeWrapper = true
    }
    else if(tmpl === 'nested'){
        element = <NestedForm key={key} field={mergedField} values={values} ref={ref} onChange={localOnChange} pk={pk} />
        excludeWrapper = true
    }       
    else if(tmpl === 'custom_field'){
        element = <CustomField key={key} {...mergedField} ref={ref} onChange={localOnChange} pk={pk} />
    }
    else if(tmpl === 'many_nested_objects'){
        element = <ManyNestedForm key={key} field={mergedField} values={values} ref={ref} onChange={localOnChange} pk={pk} inline={inline} />
        excludeWrapper = true
    }
    else{
        element = <span>Cannot render field - {tmpl} </span>
    }
    return <FieldPopover
                key={key}
                id={id}
                field={mergedField}
                formIndex={formIndex}
                popover={popover}
                value={mergedField.value}
                selectedValue={selectedValue}
        >
        <FieldWrapper excludeWrapper={excludeWrapper} key={key} loading={loading} error={error} excludeLabel={excludeLabel} index={index} formIndex={formIndex} inline={inline} field={mergedField} classCallback={classCallback} fieldClass={fieldClass} label={mergedField.label} style={mergedField.style} errors={mergedField.errors || []} children={mergedField.children} allowNull={mergedField.allowNull} hideLabel={mergedField.hideLabel} helpText={mergedField.helpText} >
            {element}
        </FieldWrapper>
    </FieldPopover>
})

export default FieldRenderer;